// Mirrors FinkitUserPagesPermissions.RiskMonitoing.LPAccounts / LpMarginThresholds.
// NB: the backend permission is singular "LPAccount" (RiskMonitoing.LPAccounts.Default
// == "User.RiskMonitoring.LPAccount"), so the plural form never matches a granted
// permission and silently hides the page + both tabs.
const LP = 'User.RiskMonitoring.LPAccount';
const LMT = 'User.RiskMonitoring.LpMarginThresholds';

export const LpAccountsPermissions = {
  default: LP,
  lpAccountsTab: `${LP}.LPAccountsTab`,
  executionQualityTab: `${LP}.ExecutionQualityTab`,
  marginThresholds: LMT,
  marginCreate: `${LMT}.Create`,
  marginEdit: `${LMT}.Edit`,
  marginDelete: `${LMT}.Delete`,
} as const;
